import { useVenturesContext } from '../../contexts/ventures-context';
import { Text } from '../common';
import { WarningModal } from '../common/warning-modal';

export function SchedulingWarningPopup() {
  const { showMentorSchedulingWarning, setShowMentorSchedulingWarning } =
    useVenturesContext();

  return (
    <WarningModal
      title='Scheduling Wizard'
      isOpen={showMentorSchedulingWarning}
      onClose={() => setShowMentorSchedulingWarning(false)}>
      <Text variant='normal'>
        Unfortunately we cannot start a scheduling wizard for this Venture on
        your behalf since you are not assigned to work with this venture. If you
        believe this is a mistake, please reach out to the admin to clarify the
        situation
      </Text>
    </WarningModal>
  );
}
